"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeViewComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var widgets_datagrid_1 = require("@tableau/widgets-datagrid");
var React = require("react");
var IndentedCellWithExpansionIndicator_1 = require("./dataGridCells/IndentedCellWithExpansionIndicator");
function getSelectionData(selectedItemId) {
    var _a;
    if (!selectedItemId) {
        return new widgets_datagrid_1.RowKeyedGridSelection();
    }
    else {
        return new widgets_datagrid_1.RowKeyedGridSelection((_a = {}, _a[selectedItemId] = true, _a));
    }
}
function buildColumnSpec(cellFormatter, selectRowOnExpansion) {
    return {
        name: TreeViewComponent.ColumnName,
        dataKey: '',
        headerText: '',
        growToFit: true,
        cellFormatter: React.createFactory((0, IndentedCellWithExpansionIndicator_1.IndentedCellWithExpansionIndicatorComponent)(cellFormatter, selectRowOnExpansion)),
    };
}
// This can't be a pure component because the expanded item key state lives inside the row store.
var TreeViewComponent = /** @class */ (function (_super) {
    __extends(TreeViewComponent, _super);
    function TreeViewComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.gridRef = React.createRef();
        _this.hasBeenFocused = false;
        /** defaults initial focus to the initially-selected item, if it was keyboard-focused */
        _this.handleInitialFocus = function (e) {
            if (_this.hasBeenFocused) {
                return;
            }
            _this.hasBeenFocused = true;
            var selectedItemId = _this.props.selectedItemId;
            if (selectedItemId) {
                if (e.target.getAttribute('role') === 'grid') {
                    _this.gridRef.current.focusCellByKey(selectedItemId);
                }
            }
        };
        /** the implementation here hacks around the way NestedRowStore is written and is NOT an example of good practice */
        _this.handleKeyDown = function (e) {
            var _a;
            var rowStore = _this.props.rowStore;
            var rowIndex = parseInt(e.target.getAttribute('aria-rowindex'), 10) - 1;
            var item = rowStore.getVisibleItem(rowIndex);
            if (!item) {
                return;
            }
            var itemKey = rowStore.getKey(item);
            var parentItemKey = rowStore.getParentKey(item);
            switch (e.key) {
                case 'ArrowRight':
                    if (!rowStore.isKeyExpanded(itemKey)) { // expand a collapsed node
                        /* the following is very ugly and should definitely be addressed in a future rewrite of this module.
                         * `TreeViewComponent<T>` doesn't have information about whether a `T` has children, so instead we check the length
                         * of the visible items before-and-after toggling, and if it didn't change, assume we mistakenly marked a leaf
                         * node as "expanded" and revert it.
                         */
                        var originalCount = rowStore.getVisibleItemCount();
                        rowStore.toggleExpansionForItemKey(itemKey);
                        if (rowStore.getVisibleItemCount() === originalCount) {
                            rowStore.toggleExpansionForItemKey(itemKey);
                        }
                        break;
                    }
                    else { // move focus to the first child of an already-expanded node, if any
                        try {
                            var nextItem = rowStore.getVisibleItem(rowIndex + 1);
                            if (nextItem && rowStore.getParentKey(nextItem) === itemKey) {
                                (_a = _this.gridRef.current) === null || _a === void 0 ? void 0 : _a.focusCellByKey(rowStore.getKey(nextItem));
                                break;
                            }
                        }
                        catch ( // there was no next item
                        _b) { // there was no next item
                            break;
                        }
                    }
                    return;
                case 'ArrowLeft':
                    if (rowStore.isKeyExpanded(itemKey)) { // collapse an expanded node
                        rowStore.toggleExpansionForItemKey(itemKey);
                        break;
                    }
                    else if (parentItemKey) { // move focus up to the parent node of an already-collapsed node
                        _this.gridRef.current.focusCellByKey(parentItemKey);
                        break;
                    }
                    return;
                case ' ': // toggle selection
                    _this.props.onItemClicked(item);
                    break;
                default:
                    return;
            }
            e.stopPropagation();
            e.preventDefault();
            _this.forceUpdate();
        };
        /**
         * "enforces" the `keepParentsOfSelectedItemExpanded` prop on the rowStore.
         *
         * Bit of a hack to accomplish two goals around two unfortunate API issues:
         * 1. `NestedRowStore` isn't written immutably/clone-able, so we update it in-place before
         * 2. immediately wrapping it, to give the DataGrid a "new" RowStore on every render, otherwise it doesn't re-render
         */
        _this.getEnforcedRowStore = function () { return ({
            getItems: function (start, end, handler) {
                if (_this.props.selectedItemId && _this.props.keepParentsOfSelectedItemExpanded) {
                    _this.props.rowStore.expandParentsOfItemKey(_this.props.selectedItemId);
                }
                return _this.props.rowStore.getItems(start, end, handler);
            }
        }); };
        if (props.selectedItemId) {
            props.rowStore.expandParentsOfItemKey(props.selectedItemId);
        }
        return _this;
    }
    TreeViewComponent.prototype.componentDidMount = function () {
        var _this = this;
        // timeout to allow the DataGrid rendering to settle first
        window.setTimeout(function () { return _this.ensureSelectedItemIsVisible(); });
    };
    TreeViewComponent.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selectedItemId !== this.props.selectedItemId) {
            this.ensureSelectedItemIsVisible();
        }
    };
    TreeViewComponent.prototype.ensureSelectedItemIsVisible = function () {
        var _a;
        if (this.props.selectedItemId) {
            var selectedRowIndex = this.props.rowStore.getRowIndex(this.props.selectedItemId);
            if (selectedRowIndex !== undefined) {
                (_a = this.gridRef.current) === null || _a === void 0 ? void 0 : _a.pageCellIntoDomThen(selectedRowIndex, 0, function (cellElem) {
                    return cellElem === null || cellElem === void 0 ? void 0 : cellElem.scrollIntoView({ block: 'nearest' });
                });
            }
        }
    };
    TreeViewComponent.prototype.render = function () {
        // tslint:disable-next-line:max-line-length
        var _a = this.props, cellFormatter = _a.cellFormatter, keepParentsOfSelectedItemExpanded = _a.keepParentsOfSelectedItemExpanded, onItemClicked = _a.onItemClicked, rowStore = _a.rowStore, selectedItemId = _a.selectedItemId, selectRowOnExpansion = _a.selectRowOnExpansion, htmlProps = __rest(_a, ["cellFormatter", "keepParentsOfSelectedItemExpanded", "onItemClicked", "rowStore", "selectedItemId", "selectRowOnExpansion"]);
        return React.createElement(widgets_datagrid_1.DataGrid, __assign({}, htmlProps, { cols: [buildColumnSpec(cellFormatter, selectRowOnExpansion)], config: GridConfig, onCellClick: onItemClicked, onFocusCapture: this.handleInitialFocus, onKeyDown: this.handleKeyDown, ref: this.gridRef, rowStore: this.getEnforcedRowStore(), selectionModel: getSelectionData(selectedItemId), showHeaders: false, showHorizontalGridLines: false, showRowBanding: false }));
    };
    return TreeViewComponent;
}(React.Component));
exports.TreeViewComponent = TreeViewComponent;
(function (TreeViewComponent) {
    TreeViewComponent.RowHeight = widgets_1.TabStyles.Sizing.RowHeight;
    TreeViewComponent.ColumnName = 'name-col';
    TreeViewComponent.ExpansionIndicatorTestId = IndentedCellWithExpansionIndicator_1.ExpansionIndicatorTestId;
})(TreeViewComponent = exports.TreeViewComponent || (exports.TreeViewComponent = {}));
exports.TreeViewComponent = TreeViewComponent;
var GridConfig = {
    rememberLastScrollPos: true,
    rowOuterHeight: TreeViewComponent.RowHeight,
};
//# sourceMappingURL=TreeViewComponent.js.map